module.exports = __webpack_public_path__ + "img/kommune-1818.3c74cac6.svg";